"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function SvgStopwatchFilled(props) {
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 32" }, props),
        React.createElement("defs", null,
            React.createElement("style", null, '.stopwatch_filled_svg__cls-1{display:none}')),
        React.createElement("g", { id: "stopwatch_filled_svg__transparent_box" },
            React.createElement("path", { className: "stopwatch_filled_svg__cls-1", d: "M0 0h32v32H0z" }),
            React.createElement("path", { className: "stopwatch_filled_svg__cls-1", d: "M0 0h32v32H0z" })),
        React.createElement("path", { d: "M24.45 9l2.26-2.26-1.42-1.45L23 7.55a11 11 0 00-6-2.5V3h3V1h-8v2h3v2.05A11 11 0 1024.45 9zm-7 8.44a2 2 0 01-2.82-2.82 1.53 1.53 0 01.41-.31V10h2v4.28a1.53 1.53 0 01.41.31 2 2 0 010 2.82z", id: "stopwatch_filled_svg__FILLED" })));
}
exports.default = SvgStopwatchFilled;
//# sourceMappingURL=StopwatchFilled.js.map